import { render, staticRenderFns } from "./PopulationSelectorComponent.vue?vue&type=template&id=380d06d4&"
import script from "./PopulationSelectorComponent.vue?vue&type=script&lang=js&"
export * from "./PopulationSelectorComponent.vue?vue&type=script&lang=js&"
import style0 from "./PopulationSelectorComponent.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports